import { Stethoscope, FlaskConical, ScanLine, type LucideIcon } from "lucide-react";
import type { OrganizationType } from "@bookdental/schemas";

export const organizationTypeOptions: {
  value: OrganizationType;
  title: string;
  description: string;
  icon: LucideIcon;
  /** MVP usa só a integração Clínica+Laboratório — oculta da grade por enquanto, sem remover do enum. */
  mvpHidden?: boolean;
}[] = [
  {
    value: "DENTAL_OFFICE",
    title: "Clínica Odontológica",
    description:
      "Dentista ou clínica com atendimento direto ao paciente. Agenda, prontuário e planos de tratamento.",
    icon: Stethoscope,
  },
  {
    value: "DENTAL_LAB",
    title: "Laboratório / Planning Center",
    description:
      "Laboratório de prótese ou centro de planejamento. Recebe casos de dentistas, entrega trabalhos e planejamentos.",
    icon: FlaskConical,
  },
  {
    value: "RADIOLOGY_CENTER",
    title: "Centro de Radiologia",
    description:
      "Clínica focada em imagem e diagnóstico. Tomografias, panorâmicas e laudos compartilhados com clínicas parceiras.",
    icon: ScanLine,
    mvpHidden: true,
  },
];

/**
 * Rótulo de DENTAL_OFFICE depende do contexto: organização pessoal representa a identidade
 * profissional de quem atende ("Cirurgião Dentista"); organização de equipe representa o
 * negócio/entidade ("Clínica Odontológica"). Os outros tipos não têm essa ambiguidade.
 */
export function getOrganizationTypeLabel(value: OrganizationType, isPersonal: boolean): string {
  if (value === "DENTAL_OFFICE") return isPersonal ? "Cirurgião Dentista" : "Clínica Odontológica";
  return organizationTypeOptions.find((o) => o.value === value)?.title ?? value;
}

/** Opções visíveis (sem as ocultas de MVP) com o rótulo já resolvido pro contexto pessoal/equipe. */
export function getVisibleOrgTypeOptions(isPersonal: boolean) {
  return organizationTypeOptions
    .filter((o) => !o.mvpHidden)
    .map((o) => ({ ...o, title: getOrganizationTypeLabel(o.value, isPersonal) }));
}
